import Combobox from "react-widgets/Combobox";
import "react-widgets/styles.css";
import useBarberService from "../../../hooks/services/useBarberService.jsx";
import AddBarberServiceModal from "./addBarberServiceModal.jsx";
import AlertMessage from "../../../components/AlertMessage.jsx";
import DeleteConfirmationModal from "../../../components/DeleteConfirmationModal.jsx";
import Breadcrumb from "../../../components/Breadcrumb";
import Table from "../../../components/Table/Table.jsx";

const BarberServices = () => {
  const {
    serviceGroup,
    seletedServiceGroup,
    setSelectedServiceGroup,
    barberList,
    seletedBarber,
    setSeletedBarber,
    services,
    notAssignedServices,
    assignedServices,
    editService,
    handleEditDuration,
    onEditClick,
    showAddModal,
    onAddServiceClick,
    addService,
    handelAddServiceToBarber,
    onServiceModalClose,
    showMessage,
    setShowMessage,
    message,
    handleDeleteService,
    handleConfirmDelete,
    onCloseDeleteModal,
    showDeleteModal,
    handleEditService,
    showEditModal,
    columns1,
    columns2,
  } = useBarberService();

  return (
    <div className="content">
      <div className="content-block">
        <Breadcrumb parent="Services" child="Services Per Staff" />
        <div className="card p-3 mb-3">
          <div className="row g-3">
            <div className="col-4 form-control-container">
              <div className="   d-flex align-items-center">
                <div className="flex-grow-1">
                  <label
                    htmlFor="staff"
                    className="form-label form-control-label"
                  >
                    Staff
                  </label>
                  <Combobox
                    onChange={(value) => setSeletedBarber(value)}
                    data={barberList}
                    dataKey="id"
                    textField="name"
                    value={seletedBarber}
                    defaultValue={seletedBarber}
                    containerClassName={" form-combobox"}
                  />
                </div>
              </div>
            </div>
            <div className="col-4 form-control-container">
              <div className="   d-flex align-items-center">
                <div className="flex-grow-1">
                  <label
                    htmlFor="group"
                    className="form-label form-control-label"
                  >
                    Service Group
                  </label>
                  <Combobox
                    onChange={(value) => setSelectedServiceGroup(value)}
                    data={serviceGroup}
                    dataKey="id"
                    textField="name"
                    value={seletedServiceGroup}
                    defaultValue={seletedServiceGroup}
                    containerClassName={" form-combobox"}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <Table
          columns={columns1}
          data={notAssignedServices}
          onEdit={onAddServiceClick}
          title={"Services Not Assigned to This Staff"}
        />
        <Table
          columns={columns2}
          data={assignedServices}
          onEdit={onEditClick}
          onDelete={handleDeleteService}
          title={"Services Assigned to This Staff"}
        />
        <AddBarberServiceModal
          isOpen={showAddModal}
          service={addService}
          onSave={handelAddServiceToBarber}
          onClose={onServiceModalClose}
        />
        <AddBarberServiceModal
          isOpen={showEditModal}
          service={editService}
          onSave={handleEditService}
          onClose={onServiceModalClose}
        />
        {showMessage && (
          <AlertMessage
            key={message.text}
            setVisible={setShowMessage}
            message={message.text}
            type={message.type}
            duration={4000}
          />
        )}
        <DeleteConfirmationModal
          show={showDeleteModal}
          onClose={onCloseDeleteModal}
          onConfirm={handleConfirmDelete}
          message="Are you sure you want to remove thisservice from this barber?"
        />
      </div>
    </div>
  );
};

export default BarberServices;
